import { useState } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import TitleContainerComponent from '../../components/layout/TitleContainerComponent';
import MainPageComponent from "../../components/page/MainPageComponent";
import useUser from '../../hooks/useUser';


function UserRegisterView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Registro', href: '' }
    ];

	const userService = useUser();

	const [user, setUser] = useState({
		name: "",
		email: "",
        password: "",
        confirmation: ""
	});

	const onSubmitForm = async (event) => {
		event.preventDefault();
		let isCreated = await userService.createUser(user);
		if (isCreated) {
			clearInputs();
			alert("Se creo el usuario");
		}
		else {
			alert("Fallo al crear el usuario");
		}
	};

	const handleInputChange = (e) => {
		setUser({
			...user,
			[e.target.name] : e.target.value
		})
	}

	const clearInputs = () => {
		setUser({
			name: "",
			email: "",
            password: "",
            confirmation: ""
		});
	}

	return (
		<div>
			<MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
				<CenterCenterVerticalContainer>
					<div className="d-flex flex-column flex-grow-1"
						style={{
							maxWidth: '25rem'
						}}
					>
						<TitleContainerComponent>
							<h1>Nuevo usuario</h1>
						</TitleContainerComponent>
						<Form onSubmit={onSubmitForm} className="border rounded p-3">
							<FormGroup>
								<Label for="name">Nombre Completo</Label>
								<Input id="name" name="name" placeholder="requerido" type="text"
									required value={user.name} onChange={handleInputChange} />
							</FormGroup>
							<FormGroup>
								<Label for="email">E-mail</Label>
								<Input id="email" name="email" placeholder="requerido"
									type="mail" required value={user.email} onChange={handleInputChange} />
							</FormGroup>
							<FormGroup>
								<Label for="password">Contraseña</Label>
                                <Input id="password" name="password" placeholder="requerido" 
									type="password" required value={user.password} onChange={handleInputChange} />
							</FormGroup>
							<FormGroup>
                                <Label for="confirmation">Confirmación de la Contraseña</Label>
                                <Input id="confirmation" name="confirmation" placeholder="requerido"
                                    type="password" required value={user.confirmation} onChange={handleInputChange} />
							</FormGroup>
							<div className="d-flex flex-column">
                                <div className="d-flex justify-content-center">
                                    <Button>Registrarse</Button>
                                </div>
                                
                                <div className="pt-2 d-flex justify-content-center">
									<a href={"/user/login"} target="_self" rel="noreferrer" id="TooltipExample" >Iniciar sesión</a>
								</div>
							</div>
						</Form>
					</div>
				</CenterCenterVerticalContainer>
			</MainPageComponent>
		</div>
	);
}

export default UserRegisterView;